/**
 * Created by mac on 12/8/20
 */

const Map2dInnerView = cc.Node.extend({
    notResizable: true,

    ctor: function (map2d) {
        this._super();

        this.map2d = map2d;
        this.scroller = map2d.scroller;

        map2d.onDiscoverMapView = function () {
            return this;
        }.bind(this);

        const visibleBox = map2d.visibleBox;

        const SIZE = map2d.getWidth() + map2d.getHeight();
        const totalWidth = SIZE * cleverapps.styles.Map2dView.cell.width / 2;
        const totalHeight = SIZE * cleverapps.styles.Map2dView.cell.height / 2;

        this.cutLeft = totalWidth * visibleBox.cutLeft;
        this.cutRight = totalWidth * visibleBox.cutRight;

        this.cutTop = totalHeight * visibleBox.cutTop;
        this.cutBottom = totalHeight * visibleBox.cutBottom;

        this.setContentSize2(totalWidth - this.cutLeft - this.cutRight, totalHeight - this.cutTop - this.cutBottom);
        this.setAnchorPoint(0.5, 0.5);

        const under = this.under = new cc.Node();

        under.setContentSize(this.getContentSize());
        under.setAlignment(this.width / 2, this.height / 2);
        under.setAnchorPoint(0.5, 0.5);
        this.addChild(under, -1);

        if (map2d.getBackgroundBundle()) {
            const background = this.background = new Map2dBackgroundView(map2d);
            background.setContentSize(this.getContentSize());
            background.setAlignment(this.width / 2, this.height / 2);
            background.setAnchorPoint(0.5, 0.5);
            this.addChild(background, -2);
        }

        const tiles = this.tiles = new cc.Node();

        tiles.setContentSize(this.getContentSize());
        tiles.setAlignment(this.width / 2, this.height / 2);
        tiles.setAnchorPoint(0.5, 0.5);
        this.addChild(tiles, 0);

        this.spotlight = new Map2dSpotlight(this);
        tiles.addChild(this.spotlight, Map2dSpotlight.ZORDER);

        const cloudsAbove = this.cloudsAbove = new cc.Node();

        cloudsAbove.setContentSize(this.getContentSize());
        cloudsAbove.setAlignment(this.width / 2, this.height / 2);
        cloudsAbove.setAnchorPoint(0.5, 0.5);
        this.addChild(cloudsAbove, 1);

        const animations = this.animations = this.movingNode = new cc.Node();

        animations.setContentSize(this.getContentSize());
        animations.setAlignment(this.width / 2, this.height / 2);
        animations.setAnchorPoint(0.5, 0.5);
        animations.debugId = "Animations";
        this.addChild(animations, 1);

        if (cleverapps.config.debugMode) {
            [this.under, this.cloudsAbove, this.animations].forEach((node) => {
                node._debugExclude = true;
            });
        }

        map2d.onAdd = this.createListener((layer, x, y, object) => {
            if (cleverapps.config.debugMode && object instanceof Unit) {
                throw "User onAddUnit to create unit view on map";
            }

            const view = this.createView(object);
            if (object && view) {
                this.addTile(layer, x, y, view);
                if (map2d.getValue(layer, x, y) === object) {
                    view.cell.view = true;
                }
            }
        });

        map2d.onAddUnit = this.createListener((x, y) => {
            this.showLayerTile(Map2d.LAYER_UNITS, x, y);
        });

        map2d.onAnimationsAdd = this.createListener((object) => {
            const view = this.createView(object);
            if (view) {
                this.animations.addChild(view);
            }
        });

        map2d.onHighlightUnit = this.createListener(this.highlightUnit.bind(this));
        map2d.onUnhighlightUnit = this.createListener(this.unhighlightUnit.bind(this));

        if (!cleverapps.environment.isAdministratorScene()) {
            this.addControls();
            cleverapps.aims.registerTarget("units", this, {
                noTargetDelta: true,
                flyingUnderShadow: true,
                flyingAnimation: Reward.SPAWN_UNITS_ANIMATION
            });
        }

        const layers = this.layers = this.getLayersOrder();
        this.layersFlat = this.layers.flat();

        this.layersViews = [];

        for (let i = 0; i < layers.length; i++) {
            const layerView = new Map2dLayerView(map2d);
            this.tiles.addChild(layerView, layers[i][0]);

            // layerView.setVisible(layers[i][0] >= 3);

            for (let j = 0; j < layers[i].length; j++) {
                this.layersViews[layers[i][j]] = layerView;
            }
        }

        this.map2d.onShowTile = this.createListener(this.showTile.bind(this));
        this.map2d.onRemoveTiles = this.createListener(this.removeTiles.bind(this));
        this.map2d.showLayerTile = this.createListener(this.showLayerTile.bind(this));
        this.map2d.updateChildrenOrder = this.createListener(this.updateChildrenOrder.bind(this));

        if (this.map2d.workers) {
            this.map2d.workers.onAddWorker = this.createListener((worker) => {
                new WorkerView(worker);
            });

            this.map2d.workers.regular.forEach(function (worker) {
                this.map2d.workers.onAddWorker(worker);
            }, this);
        }

        this.scheduleUpdateWithPriority(-1);

        this.map2d.on("stop", () => this.unscheduleUpdate());
    },

    onExit: function () {
        this._super();

        this.map2d.addViews = function () {};
        this.map2d.removeViews = function () {};
    },

    onEnterTransitionDidFinish: function () {
        this._super();

        if (this.visibleRect) {
            this.setVisibleRect(this.visibleRect);
        }
    },

    update: function (dt) {
        this._super(dt);

        if (this.controlsNode && this.scroller.getScrollView() && !this.scroller.getScrollView().touchScrollDisabled) {
            const unitTouch = this.controlsNode.getUnitTouch();
            if (unitTouch && this.borderTouchScrollIteration(this.scroller.getScrollView(), unitTouch, dt * 1500, 85)) {
                this.controlsNode.forceMoveUnit();
            }
        }

        let needUpdateShowRect = this.tilesVisibleRectDirty;

        if (needUpdateShowRect && cleverapps.config.editorMode) {
            const fps = 1 / dt;
            needUpdateShowRect = fps > 30 || (this.updateShowRectTime || 0) + 500 < Date.now();
        }

        if (needUpdateShowRect) {
            const showRect = this.getTilesShowIsoRect(this.visibleRect);
            this.map2d.setShowRect(showRect);
            this.map2d.setChildrenOrderDirty();
            delete this.tilesVisibleRectDirty;

            this.updateShowRectTime = Date.now();
        }

        this.map2d.update();
    },

    borderTouchScrollIteration: function (scrollView, touch, speed, percentage) {
        percentage *= 0.01;
        const s = scrollView.centerNode.getScale();
        const w = scrollView.width / s / 2 * percentage, h = scrollView.height / s / 2 * percentage;
        speed /= scrollView.zoom;

        const banner = cleverapps.bannerAd.getGlobalBoundingBox();
        let bannerH = 0;
        const touchLocation = touch.getLocation();
        if (banner && banner.x <= touchLocation.x && touchLocation.x <= banner.x + banner.width) {
            bannerH = scrollView.centerNode.convertToNodeSpace(cc.p(0, banner.height)).y - scrollView.centerNode.convertToNodeSpace(cc.p(0, 0)).y;
        }

        const touchPos = scrollView.centerNode.convertTouchToNodeSpace(touch);
        let dx = 0, dy = 0;
        const containerPos = scrollView.getContainerPosition();
        if (touchPos.x < -w) {
            dx = containerPos.x - speed >= scrollView.min.x ? -speed : scrollView.min.x - containerPos.x;
        }
        if (touchPos.x > w) {
            dx = containerPos.x + speed <= scrollView.max.x ? speed : scrollView.max.x - containerPos.x;
        }
        if (touchPos.y < -h + bannerH) {
            dy = containerPos.y - speed >= scrollView.min.y ? -speed : scrollView.min.y - containerPos.y;
        }
        if (touchPos.y > h) {
            dy = containerPos.y + speed <= scrollView.max.y ? speed : scrollView.max.y - containerPos.y;
        }
        if (dx || dy) {
            scrollView.scrollToPoint(cc.p(containerPos.x + dx, containerPos.y + dy));
            return true;
        }

        return false;
    },

    getLayersOrder: function () {
        const layersOrders = [
            [Map2d.LAYER_WATER],
            [Map2d.LAYER_BORDERS],
            [Map2d.LAYER_GROUND],
            [Map2d.ABOVE_GROUND]
        ];

        let fogsUnits = [[Map2d.LAYER_UNITS], [Map2d.LAYER_FOG]];
        if (Map2d.FOGS_UNITS_ONE_LAYER) {
            fogsUnits = [fogsUnits.flat()];
        }

        return layersOrders.concat(fogsUnits);
    },

    findTouchUnit: function (touch) {
        const cell = this.getCellByTouch(touch);
        if (!cell) {
            return;
        }

        const results = [];

        cc.iterateIsoRect(cc.rect(cell.x - 6, cell.y + 4, 2, 6), (x, y) => {
            this.map2d.getUnits(x, y).forEach((unit) => {
                if (unit && unit.head) {
                    unit = unit.head;
                }
                if (results.indexOf(unit) === -1) {
                    results.push(unit);
                }
            });
        });

        results.reverse();

        let bestScore = 0;
        let bestItem = undefined;

        for (let i = 0; i < results.length; i++) {
            const item = results[i];
            let score = 0;

            if (item.checkTouchInside(touch)) {
                if ((item instanceof Unit) && item.getData().isTree && !item.checkTouchInside(touch, true)) {
                    score = 1;
                } else {
                    score = 2;
                }
            }

            if (score > bestScore) {
                bestScore = score;
                bestItem = item;
            }
        }

        return bestItem;
    },

    getCellByTouch: function (touch, rawValue) {
        const pos = this.convertTouchToNodeSpace(touch);
        return this.getCellByCoordinates(pos, rawValue);
    },

    findTouchFog: function (touch) {
        const cell = this.getCellByTouch(touch);
        if (cell) {
            const additionalCells = [{ x: 0, y: 0 }, { x: -1, y: 1 }, { x: -1, y: 0 }, { x: 0, y: 1 }];
            for (let i = 0; i < additionalCells.length; i++) {
                const fog = this.map2d.getFog(cell.x + additionalCells[i].x, cell.y + additionalCells[i].y);
                if (fog) {
                    if (fog.checkPointOfInterestTouchInside(touch)) {
                        return fog;
                    }
                }
            }
            return this.map2d.getFog(cell.x, cell.y);
        }
    },

    onCellClick: function (cell, cellShift) {
        if (this.map2d.workers && this.map2d.workers.canWalk()) {
            this.animateClick(cc.pAdd(cell, cellShift), !this.map2d.workers.tryMove(cell, cellShift));
        }
    },

    getUnitCenterPos: function (x, y) {
        const unit = this.map2d.getUnit(x, y);
        let unitView = unit && unit.getShape().length > 1 && unit.onGetView();

        if (!unitView) {
            const tile = this.map2d.fogs.findTile(x, y);
            unitView = tile && tile.onGetView() && tile.onGetView().fogUnit;
        }

        if (unit && unit.onGetView() && unit.onGetView().clickRect) {
            return this.animations.convertToNodeSpace(unit.onGetView().convertToWorldSpace(cc.rectGetCenter(unit.onGetView().clickRect)));
        }

        if (unitView) {
            const boxPos = unitView.getBoundingBox();
            boxPos.x += boxPos.width / 2;
            boxPos.y += boxPos.height / 2;
            return this.animations.convertToNodeSpace(unitView.parent.convertToWorldSpace(boxPos));
        }

        if (unit && unit.isMultiCell()) {
            return this.alignPositionInGrid(
                unit.x,
                unit.y,
                MultiCellView.calcCenterPosition(unit.findComponent(MultiCell).shape)
            );
        }

        return this.alignInGrid(x, y);
    },

    addControls: function () {
        const controlsNode = this.controlsNode = new Map2dControls(this);
        this.addChild(controlsNode, -1);
    },

    addTile: function (layer, x, y, tile) {
        this.layersViews[layer].addTile(layer, x, y, tile);
        this.spotlight.onAddView(tile);
    },

    upAdditionalViewAboveClouds: function (tile, additionalView) {
        if (tile.parent) {
            additionalView.replaceParentSamePlace(this.cloudsAbove);
            additionalView.setLocalZOrder(additionalView.type === "info"
                ? Map2dInnerView.INFO_VIEW_LOCAL_Z_ORDER
                : this.getAdditionalViewLocalZOrder(tile.unit.x, tile.unit.y));
            this.spotlight.onAddView(additionalView);
        }
    },

    getAdditionalViewLocalZOrder: function (x, y) {
        return -this.map2d.height + y - x;
    },

    getFogViewLocalZOrder: function (x, y) {
        return this.getAdditionalViewLocalZOrder(x, y) - 100;
    },

    listTiles: function (layer, x, y) {
        return this.layersViews[layer].listTiles(layer, x, y);
    },

    updateChildrenOrder: function () {
        for (let i = 0; i < this.layers.length; i++) {
            this.layersViews[this.layers[i][0]].updateChildrenOrder();
        }
    },

    showTile: function (x, y) {
        for (let i = 0; i < this.layersFlat.length; i++) {
            this.showLayerTile(this.layersFlat[i], x, y);
        }
        this.map2d.edges.addViews(x, y);
        this.map2d.decorators.addDecoratorsViews(x, y);
    },

    showLayerTile: function (layer, x, y) {
        if (!this.map2d.isVisibleCell(x, y)) {
            this.map2d.showTile(x, y);
            return;
        }

        this.layersViews[layer].showLayerTile(layer, x, y);
    },

    getCellLayerTile: function (layer, x, y) {
        return this.layersViews[layer].getCellLayerTile(layer, x, y);
    },

    removeTiles: function (cells) {
        for (let i = 0; i < this.layers.length; i++) {
            this.layersViews[this.layers[i][0]].removeTiles(cells);
        }
    },

    animateClick: function (cell, warning) {
        const missClickJson = warning && bundles.merge.jsons.miss_click && bundles.merge.jsons.miss_click.resolve();
        const clickAnimation = new cleverapps.Spine(missClickJson || bundles.merge.jsons.ground_click);
        clickAnimation.setAnimation(0, "animation", false);
        clickAnimation.setCompleteListenerRemove();
        clickAnimation.setSafeToRemove();
        clickAnimation.setLocalZOrder(10);
        this.addTile(Map2d.LAYER_UNITS, Math.round(cell.x) + 2, Math.round(cell.y) - 2, clickAnimation);

        clickAnimation.setPosition(this.getCoordinatesByCell(cell));

        if (warning && !missClickJson) {
            clickAnimation.setColor(cleverapps.styles.COLORS.COLOR_RED);
        }
    },

    containsView: function (unitView) {
        return unitView.parent && unitView.parent.cell;
    },

    highlightUnit: function (unit, f, options = {}) {
        const unitView = unit.onGetView();

        if (!this.highlighter && unitView) {
            this.runAction(new cc.Sequence(
                new cc.HighlightUnit(unit, options),
                new cc.DelayTime(0.2),
                new cc.CallFunc(f)
            ));
        } else {
            f();
        }
    },

    unhighlightUnit: function (f) {
        this.runAction(new cc.Sequence(
            new cc.UnhighlightUnit(),
            new cc.CallFunc(f)
        ));
    },

    watchInfoViewHovered: function (infoView) {
        cleverapps.UI.applyHover(infoView, {
            onMouseOver: () => {
                this.hoveredInfoView = infoView;
            },
            onMouseOut: () => {
                if (this.hoveredInfoView === infoView) {
                    delete this.hoveredInfoView;
                }
            }
        });
        infoView.addCleaner(() => {
            if (this.hoveredInfoView === infoView) {
                delete this.hoveredInfoView;
            }
        });
    }
});

Map2dInnerView.prototype.setVisibleRect = function (visibleRect) {
    this.visibleRect = visibleRect;

    this.map2d.setScreenRect(this.screenRectToIso(visibleRect));
    this.tilesVisibleRectDirty = true;

    if (this.background) {
        this.background.setVisibleRect(visibleRect);
    }
};

Map2dInnerView.prototype.screenRectToIso = function (rect) {
    const cell = this.getCellByCoordinates(rect);
    const width = Math.round(rect.width / cleverapps.styles.Map2dView.cell.width);
    const height = Math.round(rect.height / cleverapps.styles.Map2dView.cell.height);
    return cc.rect(cell.x, cell.y, width, height);
};

Map2dInnerView.prototype.getTilesShowIsoRect = function (screenRect) {
    const styles = cleverapps.styles.Map2dView.cell;

    const frame = this.map2d.tilesVisibleRectFrame;

    let showRect = cc.rect(
        screenRect.x + frame.x * styles.width,
        screenRect.y + frame.y * styles.height,
        screenRect.width + frame.width * styles.width,
        screenRect.height + frame.height * styles.height
    );

    const showCells = {};

    const addCell = (cell) => {
        if (!showCells[cell.y]) {
            showCells[cell.y] = {};
        }
        showCells[cell.y][cell.x] = true;
    };

    const decorators = this.map2d.decorators.getLargeDecorators();
    for (let i = 0; i < decorators.length; i++) {
        const decorator = decorators[i];
        const cellRect = decorator.getCellRect();
        const largeBox = decorator.getLargeBox();

        if (cc.rectIntersectsRect(screenRect, largeBox) && !cc.rectContainsRect(showRect, cellRect)) {
            addCell(decorator);
        }
    }

    if (this.map2d.workers) {
        for (const worker of this.map2d.workers.listRegular()) {
            addCell(worker.getMapPosition());
        }
    }

    showRect = this.screenRectToIso(showRect);
    showRect.cells = showCells;

    return showRect;
};

Map2dInnerView.prototype.getCellByCoordinates = function (p, rawValue) {
    const zero = this.alignInGrid(0, 0);
    const coors = Map2dInnerView.ScreenToIso(p.x - zero.x, p.y - zero.y);
    if (rawValue) {
        return coors;
    }
    return cc.p(Math.round(coors.x), Math.round(coors.y));
};

Map2dInnerView.prototype.getCoordinatesByCell = function (cell) {
    const zero = this.alignInGrid(0, 0);
    const coors = Map2dInnerView.IsoToScreen(cell.x, cell.y);
    return cc.p(coors.x + zero.x, coors.y + zero.y);
};

Map2dInnerView.INFO_VIEW_LOCAL_Z_ORDER = 1;

Map2dInnerView.ScreenToIso = function (x, y) {
    const dx = x / cleverapps.styles.Map2dView.cell.width;
    const dy = y / cleverapps.styles.Map2dView.cell.height;

    return {
        x: dx + dy,
        y: dx - dy
    };
};

Map2dInnerView.IsoToScreen = function (x, y) {
    const dx = (x + y) / 2;
    const dy = (x - y) / 2;

    return {
        x: dx * cleverapps.styles.Map2dView.cell.width,
        y: dy * cleverapps.styles.Map2dView.cell.height
    };
};

Map2dInnerView.prototype.toScreen = function (x, y) {
    return Map2dInnerView.IsoToScreen(x, y);
};

Map2dInnerView.prototype.getCell = function (x, y) {
    return new Map2dCellView(x, y, this);
};

Map2dInnerView.prototype.hasView = function (layer, x, y) {
    const object = this.map2d.getValue(layer, x, y);
    this.map2d.setPointer(x, y);

    return object instanceof FogTile || object instanceof Highlight || object instanceof BorderTile
        || object instanceof Unit && !this.map2d.getFog(object.x, object.y) && !object.isMultiCellBody()
        || ViewReader.hasView(object)
        || this.map2d.decorators.hasView(layer, x, y);
};

Map2dInnerView.prototype.createView = function (object) {
    if (object instanceof FogTile) {
        return new FogTileView(object);
    }
    if (object instanceof Highlight) {
        return new HighlightView(object);
    }

    if (object instanceof Unit) {
        if (cleverapps.config.debugMode && !Map2d.unitsVisible || object.isMultiCellBody()) {
            return;
        }
        return new UnitView(object);
    }

    if (cleverapps.config.debugMode && !Map2d.groundVisible) {
        return;
    }

    if (object instanceof BorderTile) {
        return Map2dBorderView.GetFromPool(object);
    }

    return ViewReader.parse(object, this.map2d);
};

Map2dInnerView.prototype.alignInGrid = function (x, y) {
    const X = x + y + 1;
    const Y = (x - y) + this.map2d.getHeight();
    return cc.p(X * cleverapps.styles.Map2dView.cell.width / 2 - this.cutLeft, Y * cleverapps.styles.Map2dView.cell.height / 2 - this.cutBottom);
};

Map2dInnerView.prototype.alignViewInGrid = function (x, y, view) {
    const cellPosition = this.alignInGrid(x, y);
    const alignmentComponent = ComponentMap.get(view, AlignmentComponent);
    let position = alignmentComponent ? alignmentComponent.alignment : view.getPosition();
    position = view.positionFromAlignment(position.x, position.y, { parentSize: { width: 0, height: 0 } });
    position.x += cellPosition.x;
    position.y += cellPosition.y;

    view.setAlignment(position.x, position.y);
};

Map2dInnerView.prototype.alignPositionInGrid = function (x, y, position) {
    const cellPosition = this.alignInGrid(x, y);
    return cc.p(position.x + cellPosition.x, position.y + cellPosition.y);
};

Map2dInnerView.prototype.wrapWithScroll = function (onPositionChanged) {
    this.scroller.onPositionChangedListener = () => {
        this.map2d.onPositionChanged();
        onPositionChanged();
    };

    return new Map2dScrollView(this.scroller, this, {
        childrenVisibility: false,
        scrollBarEnabled: false,
        zoom: this.getZoomOptions(),
        outOfBoundaryScale: cleverapps.skins.getSlot("outOfBoundaryScale"),
        inertialScrollFactor: 0.2
    });
};

Map2dInnerView.prototype.getZoomOptions = function () {
    if (cleverapps.config.demoMode) {
        return { minZoom: 0.2 };
    }

    if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
        return { minZoom: 0.4, maxZoom: 1 };
    }

    return true;
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MERGE_BONUS_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.COLOR_RED,
        stroke: {
            color: cleverapps.styles.COLORS.WHITE,
            size: 2
        }
    }
});

cleverapps.styles.Map2dView = {
    cell: {
        width: 174,
        height: 100
    }
};
